<template>
  <Header />
    <div
      class="content"
      v-if="isNotFound"
    >
      <NotFound />
    </div>
    <div v-else>
      <div class="top-visual">
        <div class="frame_img">
          <img
            :src="detailGroupArea?.file ? detailGroupArea?.file : trademarkLogo"
            alt=""
            id="myImg"
            style="width: 100%; height: 100%; max-height: 250px"
          />
          <div class="img-content" v-if="!isLoading">
            <h1>{{ detailGroupArea?.name || 'おすすめ' }}の貸し会議室・レンタルスペース・イベント会場</h1>
            <div class="img-sub-content for-pc" v-if="detailGroupArea?.area_names">
              {{ detailGroupArea?.area_names }}
              <span>
                でおすすめの貸し会議室・レンタルスペース一覧です。<br />
                タイムシェアリングが運営する少人数から大人数まで利用可能な、格安・オシャレな貸し会議室・レンタルスペースを掲載しています。
              </span>
            </div>
            <div class="img-sub-content for-sp" v-if="detailGroupArea?.area_names">
              <span>
                {{ detailGroupArea?.area_names }}で <br />
                おすすめの貸し会議室・レンタルスペース一覧です。<br />
                タイムシェアリングが運営する
                少人数から大人数まで利用可能な格安・オシャレな
                貸し会議室・レンタルスペースを掲載しています。
              </span>
            </div>
            <div class="for-pc">
              ★おすすめ用途★
              <span v-if="detailGroupArea?.name_purpose_of_uses">{{detailGroupArea.name_purpose_of_uses}}</span>
            </div>
          </div>
        </div>
      </div>
      <div id="js-search-sticky" class="search-bar js-search-bar-sticky">
        <SearchBar :researchValue="researchValue" @emitSort="emitSort" :totalSpace="TotalSpace"/>
      </div>

      <div class="location-content-container">
        <div class="lg:mb-[20px] mt-[20px] flex justify-center" v-if="!isLoading">
          <h2 class="text-[22px] font-bold text-center lg:text-2xl">{{ detailGroupArea.name }}の貸し会議室・レンタルスペース・イベント会場を一覧から探す</h2>
        </div>
        <div class="list_space">
          <SearchSpaces :researchValue="researchValue" v-if="researchValue" :isSort="isSort" :valueSort="valueSort" :isLoading="isLoading" @emitTotalSpace="emitTotalSpace"/>
        </div>
        <div v-if="queryCategory == ''">
          <GroupAreaRecommendSpaces
            :researchValue="researchValue"
            :nameGroupArea="detailGroupArea?.name"
            v-if="researchValue.group_area"
          />
        </div>

        <AreaList v-if="store.getListGroupArea?.length" :listLocation="store.getListGroupArea" :researchValue="researchValue"/>
        
        <div class="other-areas" v-if="queryCategory != ''">
          <ReasonList :detail-location-name="detailLocation?.name" :name-category="nameCategory"/>
        </div>
        
        <div class="c-features_list"
          v-if="listFeatures && listFeatures?.length && queryGroupArea != ''">
          <div v-for="(listFeature, key) in listFeatures" :key="listFeature">
            <div class="content_space">
              <div class="content-title">
                <h2>{{ listFeature?.heading }}</h2>
                <span style="color: #000; font-size: 18px; font-weight: 400; line-height: normal;">{{ !key ? 'Characteristics' : 'Access' }}</span>
              </div>
              <div v-for="content in listFeature?.contents" :key="content" class="one-content">
                <span class="content-image-pc">
                  <img 
                    :src="!key ? areaFeatureCharacteristicsLogo : areaFeatureAccessLogo"
                    :alt="!key ? `特徴` : `アクセス`"
                    style="width: 54px; height: 54px;"
                  />
                </span>
                <div class="content-text">
                  <h3>
                    {{ content?.title }}
                  </h3>
                  <hr class="gradation-line" />
                  <p>{{ content?.description }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="c-faq_list" v-if="listFaq && listFaq?.length && queryGroupArea !== ''">
          <div class="content_space faq-line">
            <div class="c-faq_list_title">
              <h2>
                <span>{{ detailGroupArea?.name }}の貸し会議室・レンタルスペースに関する</span><span style="color: #2b7eca">よくある質問</span>
              </h2>
              
              <p>Frequently Asked Questions</p>
            </div>
            <dl v-for="faq in listFaq" :key="faq">
              <dt>
                <img
                  :src="question"
                  alt="質問のロゴ"
                  class="faq_content-image-sp"
                  style="height: 60px; width: 60px;"
                />
                <h3>{{ faq.question }}</h3>
              </dt>
              <dd>
                <img :src="answer" alt="回答のロゴ" class="faq_content-image-sp" style="height: 60px; width: 60px;"/>
                <p style="white-space: pre-wrap;" v-html="faq.answer"></p>
              </dd>
            </dl>
          </div>
        </div>

        <div class="content_space c-list_statistics" v-if="statistics && statistics?.length && queryGroupArea != ''">
          <div class="content-title">
            <h2 class="d-inline">
              <span style="color: #222; font-size: 24px;">{{ detailGroupArea?.name }}</span>
              <span class="d-inline">の貸し会議室・レンタルスペースの統計情報</span>
            </h2>
            <p style="color: #222; font-size: 18px; font-weight: 400;" class="d-block">Statistics</p>
          </div>
          <div class="one-content one-content-data">
            <div
              class="content-statistics"
              v-for="statistic in statistics"
              :key="statistic.id"
            >
              <h3 class="statistics-item">{{ statistic.title }}</h3>
              <div class="statistics-data">{{ statistic.information }}</div>
              <div style="white-space: pre-wrap;" class="statistics-text" v-html="statistic.introduction"></div>
            </div>
          </div>
        </div>

        <CategoriesList v-if="store.getListCategory?.length" :listCategory="store.getListCategory" :researchValue="researchValue"/>
        
        <div class="content_space_group">
          <span v-if="detailGroupArea?.note" style="white-space: pre-wrap" v-html="detailGroupArea?.note"></span>
        </div>
      </div>

      <div class="pre_footer">
        <div class="inner-wrap">
          <ol
            class="breadcrumb"
            itemscope
            itemtype="https://schema.org/BreadcrumbList"
          >
            <li
              itemprop="itemListElement"
              itemscope
              itemtype="https://schema.org/ListItem"
              name="top page"
            >
              <a itemprop="item" href="/">
                <span itemprop="name">TIME SHARING（タイムシェアリング）</span>
              </a>
              <meta itemprop="position" content="1" />
            </li>
            <li
              itemprop="itemListElement"
              itemscope
              itemtype="https://schema.org/ListItem"
              name="area page"
            >
              <a itemprop="item" href="#">
                <span itemprop="name">エリア</span>
              </a>
              <meta itemprop="position" content="2" />
            </li>
            <li itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem" name="area detail page">
                <a itemprop="item" href="#" >
                  <span itemprop="name">{{ detailGroupArea?.name }}の貸し会議室・レンタルスペース一覧</span>
                </a>
                <meta itemprop="position" content="3" />
            </li>
          </ol>
        </div>
      </div>
    </div>
  <Footer />
  <ContactInfo />
</template>

<script setup>
import { ref, watch, onMounted, onUnmounted, defineAsyncComponent, onUpdated } from "vue";
import Header from "@/client/organisms/LayoutHome/Header/Header.vue";
import Footer from "@/client/organisms/LayoutHome/Footer/Footer.vue";
import ContactInfo from "@/client/organisms/LayoutHome/ContactInfo/ContactInfo.vue";
import question from "@/client/assets/images/q.png";
import answer from "@/client/assets/images/a.png";
import { useRoute } from "vue-router";
import Lodash from 'lodash';
import {
  getListGroupAreaFaqApi,
  getListGroupAreaFeaturesApi,
  getListGroupAreaStatisticsApi,
  getListGroupAreaApi,
} from "@/client/api";
import { FAQ_TYPE } from '@/client/const'
import useCustomer from "@/client/store/Customer";
import useStore from "@/client/store/Customer";
import SearchBar from "@/client/components/SearchBar/SearchBar.vue";
import SearchSpaces from "@/client/components/Space/SearchSpaces.vue";
import ReasonList from "@/client/components/Reasons/ReasonList.vue";
import GroupAreaRecommendSpaces from "@/client/components/Space/GroupAreaRecommendSpaces.vue";
import trademarkLogo from "@/client/assets/images/location_shibya-1500x573.webp";
import LoadingScreen from "@/admin/components/Loading/LoadingScreen.vue";
import areaFeatureCharacteristicsLogo from "@/client/assets/images/area_feature_logo.svg";
import areaFeatureAccessLogo from "@/client/assets/images/area_access_logo.svg";
import { reactive } from "vue";
import NotFound from "@/client/components/NotFound/NotFound.vue";

const CategoriesList = defineAsyncComponent({
  loader: () => import('@/client/components/Categories/CategoriesList.vue'),
  loadingComponent: LoadingScreen,
  delay: 10000,
  timeout: 3000
})

const AreaList = defineAsyncComponent({
  loader: () => import('@/client/components/Areas/AreaList.vue'),
  loadingComponent: LoadingScreen,
  delay: 10000,
  timeout: 3000
})

const route = useRoute();
const statistics = ref([]);
const detailGroupArea = ref([]);
const groupAreaId = ref();
const groupArea = ref({});
const listGroupArea = ref([])
const storeCustomer = useCustomer();
const category = ref();
const listFaq = ref();
const listFeatures = ref();
const categorySlug = route.params.categorySlug;
const isLoading = ref(false);
const queryCategory = ref(route.query?.category ?? '');
const queryGroupArea = ref();
const store = useStore();
const TotalSpace = ref(0)
const isSort = ref(false);
const valueSort = ref();
const nameCategory = ref();
const areaId = ref(null);
const isNotFound = ref(false);

const listPeople = reactive([
  { name: "ブース(個室)", id: "1-5" },
  { name: "〜20人", id: "6-20" },
  { name: "21〜40人", id: "21-40" },
  { name: "41〜60人", id: "41-60" },
  { name: "61〜100人", id: "61-100" },
  { name: "100人〜", id: "101-" },
]);

const researchValue = ref({
  group_area: route.query.group_area ? route.query.group_area : "",
  lp: route.query.lp ? route.query.lp : "",
  date: route.query.date ? route.query.date : "",
  timeStart: route.query.timeStart ? route.query.timeStart : "",
  timeEnd: route.query.timeEnd ? route.query.timeEnd : "",
  category: route.query.category ? route.query.category : "",
  people: route.query.people ? route.query.people : "",
  dateTime: route.query.date
    ? route.query.date + " " + route.query.timeStart + "~" + route.query.timeEnd
    : "",
  search_sort: route.query.search_sort ? route.query.search_sort : ""
});

onUpdated(() => {
  const researchVal = researchValue.value;
  let searchTitle = "";
  if (researchVal.group_area) {
    const listLocation = Array.from(store.getListGroupArea);
    const currentAreaName = listLocation.find(loc => loc.id && loc.id == researchVal.group_area)?.name ?? '';
    searchTitle = `${currentAreaName}の貸し会議室・レンタルスペース・イベント会場｜【公式】タイムシェアリング
`
  }
  else if (researchVal.category) {
    const listCategory = Array.from(store.getListCategory);
    const currentCategoryName = listCategory.find(cate => cate.id && cate.id == researchVal.category)?.name ?? '';
    searchTitle = `${currentCategoryName}の貸し会議室・レンタルスペース・イベント会場｜【公式】タイムシェアリング`
  }
  else if (researchVal.people) {
    const currentPeopleName = listPeople.find(ppl => ppl.id && ppl.id == researchVal.people)?.name ?? '';
    searchTitle = `${currentPeopleName}の貸し会議室・レンタルスペース・イベント会場｜【公式】タイムシェアリング`
  }
  else if (researchVal.date && researchVal.timeStart && researchVal.timeEnd) {
    const fullDateTime = researchVal.date + ' ' + researchVal.timeStart + '～' + researchVal.timeEnd;
    searchTitle = `${fullDateTime}に使える貸し会議室・レンタルスペース・イベント会場｜【公式】タイムシェアリング`
  }
  else {
    searchTitle = `貸し会議室・レンタルスペース・イベント会場｜【公式】タイムシェアリング`
  }
  document.title = searchTitle;
})

onMounted(async () => {
  isLoading.value = true;
  const res = await getListGroupAreaApi();
  const listGroupAreaData = res.data

  listGroupArea.value = listGroupAreaData;
  if (listGroupAreaData.length) {
    if(route.params.area_slug) {
      const foundGroupArea = listGroupAreaData.find(
        (element) => element.slug == route.params.area_slug
      );
      if (foundGroupArea && foundGroupArea?.id) {
        isNotFound.value = false;
        groupArea.value = listGroupAreaData
          ?.filter((groupArea) => groupArea.id == foundGroupArea.id)
          .shift();
        detailGroupArea.value = groupArea.value;
        if (!groupArea.value?.id) {
          storeCustomer.isLoading = false;
        }
        researchValue.value.group_area = groupArea.value.id;
        const statisticsRes = await getListGroupAreaStatistics(groupArea.value?.id);
        if (detailGroupArea.value?.statistics) {
          detailGroupArea.value.statistics = statisticsRes;
        }
        if (detailGroupArea.value?.file) {
          detailGroupArea.value.file = `${detailGroupArea.value?.file}`;
        }
        groupAreaId.value = groupArea.value?.id;
        queryGroupArea.value = foundGroupArea?.id;
      } else {
        isNotFound.value = true;
      }
    }
  }
  const categoryData = store.listCategory;
  if (categoryData.length) {
    category.value = categoryData
      .filter((category) => category.slug == categorySlug)
      .shift();
  }
  isLoading.value = false;
  await getListGroupAreaFaq(queryGroupArea.value);
  await getListGroupAreaFeatures(queryGroupArea.value);
  await getListGroupAreaStatistics(queryGroupArea.value)
  createTitleDesc(route);
  storeCustomer.isLoading = false;
});

const scrollTop = () => {
  window.scrollTo(0, 0);
};

watch(
  () => route,
  async () => {
    if (route.query?.group_area && detailGroupArea.value?.id != route.query?.group_area) {
      isLoading.value = true
      if (store.getListGroupArea.length) {
        const foundGroupArea = store.getListGroupArea.find(
          (element) => element.id == route.query?.group_area
        );
        if (foundGroupArea && foundGroupArea?.slug) {
          let areaInfo = store.getListGroupArea
            ?.filter((area) => area.slug == foundGroupArea.slug)
            .shift();
          if (areaInfo) {
            await getListGroupAreaStatistics(areaInfo.id);
            detailGroupArea.value = areaInfo;
            areaId.value = areaInfo.id;
            if (detailGroupArea.value?.file) {
              detailGroupArea.value.file = `${detailGroupArea.value?.file}`;
            }
            await getListGroupAreaStatistics(queryGroupArea.value)
            await getListGroupAreaFaq(queryGroupArea.value);
            await getListGroupAreaFeatures(queryGroupArea.value);
            createTitleDesc(route);
            scrollTop();
          }
        }
      }
      isLoading.value = false
    }
  },
  { deep: true }
);

watch(route,
  async()=>{
    if (route.query?.group_area) {
      groupArea.value = route.query?.group_area
      detailGroupArea.value = store.listGroupArea.find((item) => item.id == groupArea.value)
      isLoading.value = false;
    } else if(route.params.area_alug) {
      detailGroupArea.value = store.listGroupArea.find((item) => item.slug == route.params.area_alug)
      groupArea.value = detailGroupArea.value.id
      isLoading.value = false;
    } else {
      detailGroupArea.value = {}
      isLoading.value = false;
    }
    if(route.query) {
      queryCategory.value = route.query?.category ?? ''
      queryGroupArea.value = route.query?.group_area ?? ''
      researchValue.value.search_sort = route.query?.search_sort ?? ''
      if(queryGroupArea.value != ''){
        await getListGroupAreaStatistics(queryGroupArea.value)
        await getListGroupAreaFaq(queryGroupArea.value);
        await getListGroupAreaFeatures(queryGroupArea.value);
      }else{
        groupArea.value = {}
        researchValue.value.group_area = '';
        detailGroupArea.value = {}
      }
      if(queryCategory.value) {
        const arrCategory = store.listCategory
        if(Array.isArray(arrCategory)) {
          const foundItem = arrCategory?.find((item)=> item.id == queryCategory.value)
            if (foundItem) {
              nameCategory.value = foundItem.name;
            } else {
              nameCategory.value = ''
            }
          }
      }
    }
  }
)

const getListGroupAreaStatistics = async (groupAreaId) => {
  if (groupAreaId) {
    try {
      const res = await getListGroupAreaStatisticsApi(groupAreaId);
      statistics.value = res.data;
      return res.data;
    } catch (errors) {
      // error
    } finally {
      storeCustomer.isLoading = false;
    }
  }
};

const getListGroupAreaFaq = async (groupAreaId) => {
  try {
    if (groupAreaId) {
      const faq = await getListGroupAreaFaqApi(groupAreaId);
      listFaq.value = faq.data?.map(item => {
        const flagReplaceAreaName = item.type === FAQ_TYPE.NORMAL ? detailGroupArea.value.area_names : detailGroupArea.value.area_names_sub_faq
        const question = item.question.replace(/\[area names\]/g, flagReplaceAreaName ?? '').replace(/駅駅/g, '駅');
        const answer = item.answer ? item.answer.replace(/\[area names\]/g, flagReplaceAreaName ?? '').replace(/駅駅/g, '駅') : null;
        return {
              question,
              answer,
          }
      });
    }
  } catch (errors) {
    // error
  } finally {
    // finally
  }
};

const getListGroupAreaFeatures = async (groupAreaId) => {
  try {
    if (groupAreaId) {
      const features = await getListGroupAreaFeaturesApi(groupAreaId);
      listFeatures.value = features.data;
    }
  } catch (errors) {
      // error
  } finally {
      // finally
  }
};

function createTitleDesc(routeInstance) {
  const nameSpace = detailGroupArea.value?.name ?? '';

  // メタタグのdescription設定処理
  if (routeInstance.meta.description) {
    document
      .querySelector("meta[name='description']")
      .setAttribute("content", nameSpace + routeInstance.meta.description);
  }
}

const width = ref(window.innerWidth);
const handleStickyNavSP = () => {
  const heightHeader = document.querySelector('.header').offsetHeight;
  const searchBar = document.getElementsByClassName('js-search-bar-sticky');
  if (width.value < 601) {
    searchBar[0].style.top = heightHeader - 1 + 'px'
  } else {
    searchBar[0].style.top = heightHeader - 1 + 'px'
  }
}
const handleResize = Lodash.debounce(() => {
  width.value = window.innerWidth;
  handleStickyNavSP();
}, 500);
onMounted(() => {
  window.addEventListener('resize', handleResize);
});
onUnmounted(() => {
  window.removeEventListener('resize', handleResize);
});
onMounted(() => {
  const searchBar = document.getElementsByClassName('search-bar');
  const searchContainer = document.getElementsByClassName('search-bar-container');
  const c_sort = document.getElementsByClassName('c-sort');
  window.addEventListener('scroll', () => {
    if (window.scrollY > 180) {
      if(searchBar[0]){
        searchBar[0].classList.add('js-sticky');
        searchContainer[0].classList.add('js-sticky-cont');
        handleStickyNavSP();
        if(c_sort[0]) { c_sort[0].style.display = "none";}
      }
    } else {
      if(searchBar[0]){
        searchBar[0].classList.remove('js-sticky');
        searchContainer[0].classList.remove('js-sticky-cont');
      }
      if(c_sort[0]) { c_sort[0].style.display = "unset";}
    }
  });
});

const emitTotalSpace = (data) => {
  TotalSpace.value = data
};
const emitSort = (data, valSort) => {
  isSort.value = data;
  valueSort.value= valSort
};
</script>

<style scoped lang="scss">
@import "@/client/views/ListAreaByCategory/ListAreaByCategory.scss";
@import "@/client/organisms/LayoutHome/Breadcrumb/Breadcrumb.scss";
@import "@/client/organisms/HomePage/RentalSpaceReasons/RentalSpaceReasons.scss";
@import "./Style.scss";
.c-faq_list_title {
  text-align: center;
  margin-bottom: 20px;
  h2 {
    @media (max-width:575px) {
        text-align: left;
    }
    span {
      color: #000;
      font-size: 24px;
      font-weight: 700;
      line-height: normal;
    }
  }
  p {
    color: #000;
    font-size: 18px;
    font-weight: 400;
    line-height: normal;
  }
}
.js-sticky {
  position: sticky;
  background: #fff;
  box-shadow: rgba(17, 17, 26, 0.1) 0px 1px 0px;
  z-index: 9;
    .search-bar-container {
        padding-left: 5px;
        padding-right: 15px;
        justify-content: space-between;
        gap: 10px;
    }
    .search-form.for-pc {
        border: none;
    }
}
.search-bar {
  position: sticky;
    top: 137px;
    margin-top: -85px;
    width: 100%;
    z-index: 9;
    .sort-container {
        display: none;
    }
    &.js-sticky {
        .sort-container {
            min-width: 275px;
            display: flex;
            width: auto;
        }
    }
}
@media (max-width: 768px) {
    .search-bar {
        margin-top: -42px;
    }
    .c-faq_list, .c-features_list, .c-list_statistics {
      padding: 0 14px;
    }
}
@media (max-width: 767px) {
    .search-bar {
        &.js-sticky {
            .sort-container {
                display: none;
            }
        }
        .search-bar-container {
            justify-content: center;
            padding-right: 5px;
        }
    }

}

@media (max-width:575px){
    .c-features_list{
        padding: 0px;
    }
    .content_space .content-title{
        padding: 10px 0px;
    }
    .content_space .content-title h2{
        text-align: left;
        display: block !important;
    }
    .content_space .content-text{
        padding: 0px 14px;
    }
    .content_space.c-list_statistics {
        padding: 0px;
    }
    .content_space .one-content.one-content-data .content-statistics{
        width: 100%;
        padding: 5px 14px;
    }
}
</style>
